'use client';

import { useEffect, useState } from 'react';

export interface UseWindowWidthReturn {
    isMobile: boolean;
    isTablet: boolean;
    isDesktop: boolean;
    windowWidth: number;
}

export function useWindowWidth(): UseWindowWidthReturn {
    // TODO: consider replacing with matchMedia for better performance.  Leaving in place for now, since this hook is not yet being used.
    // Believe there might have been an issue where js and css windowWidths were not matching properly, resulting in the need to use document.documentElement.clientWidth
    // if this proves not to be the case matchMedia is preferred --> https://www.w3schools.com/jsref/met_win_matchmedia.asp
    const [windowWidth, setWindowWidth] = useState<number>(
        typeof document !== 'undefined'
            ? document?.documentElement.clientWidth
            : 0
    );

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(document.documentElement.clientWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return {
        isMobile: windowWidth < 768,
        isTablet: windowWidth >= 768 && windowWidth < 960,
        isDesktop: windowWidth >= 960,
        windowWidth,
    };
}
